export const NEXT = 'Next';
export const BACK = 'Back';
export const CREATE_ACCOUNT = 'Create Account';
export const CONTINUE = 'Continue';
export const CANCEL = 'Cancel';
export const UPDATE = 'Update';
export const DONE = 'Done';
